import { render } from "./CalendarEventOffersSearchableList.vue?vue&type=template&id=67673d0a&scoped=true"
import script from "./CalendarEventOffersSearchableList.vue?vue&type=script&lang=ts"
export * from "./CalendarEventOffersSearchableList.vue?vue&type=script&lang=ts"

import "./CalendarEventOffersSearchableList.vue?vue&type=style&index=0&id=67673d0a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-67673d0a"

export default script